import { createWebHashHistory, createRouter } from "vue-router";

export const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            component: () => import('./components/subscription/Subscription.vue')
        },
        {
            path: '/unsubscribe',
            name: 'unsubscribe',
            component: () => import('./components/subscription/Unsubscribe.vue')},
        {
            path: '/thank-you',
            component: () => import('./components/subscription/ThankYou.vue')},
        {
            path: '/thank-you-new',
            component: () => import('./components/subscription/ThankYouNewUser.vue'),
        },
        {
            path: '/reports-unsubscribe',
            component: () => import('./components/subscription/ReportsUnsubscribe.vue'),
        },
        {
            path: '/donate/:defaultPrice?/:customNote?',
            component: () => import('./components/subscription/Donate.vue'),
            props: true
        },
        {
            path: '/thank-you-donate/:sessionHash?',
            name: 'thank-you-donate',
            component: () => import('./components/subscription/DonateThankYou.vue'),
            props: true
        },
        {
            path: '/invite-subscription',
            component: () => import('./components/subscriptions/group-subscriptions/MemberInvites.vue'),
        },
        {
            path: '/invite-subscription-accept',
            component: () => import('./components/subscriptions/group-subscriptions/MemberAcceptInvite.vue'),
        },
        {
            path: '/thank-you-group-subscription',
            component: () => import('./components/subscriptions/group-subscriptions/ThankYou.vue'),
        },

        {path: "/:catchAll(.*)", redirect: '/'},
    ]
})

export default router
